import sqftToMeter from '@/utils/sqft-to-meters'
import toInteger from '@/utils/to-integer'

const isMeters = formatString =>
  formatString && formatString.toLowerCase() === 'meter'

export const formatSize = (formatString, size) =>
  isMeters(formatString) ? toInteger(sqftToMeter(size)) : size

export const formatSizeLabel = formatString =>
  isMeters(formatString) ? 'm²' : 'ft²'
